<template lang="html">
  <div>
    <div class="comment" v-if="canComment">
      <product v-if="toSku" :vorderDetail="order" />
      <star v-if="toSku" :vorderDetail="order" />
      <singleStar v-else />
      <comment :tagList="tagList" :toSku="toSku" />
      <upload :toSku="toSku" />
      <serviceStar v-if="toSku" />
      <!-- <a v-if="commentDigest.link && commentDigest.title" :href="commentDigest.link" event-param="20000|21071">
            <div class="comment-way">
                {{commentDigest.title}}
                <i class="iconfont icon-jiantou"></i>
            </div>
        </a> -->
      <actionbar>
        <button
          class="btns btn-pink"
          slot="buttons"
          @click="postCommentToSku"
          v-if="toSku"
        >
          发表评论
        </button>
        <button
          class="btns btn-pink"
          slot="buttons"
          @click="postCommentToPerson"
          v-else
        >
          发表评论
        </button>
      </actionbar>
    </div>
    <empty v-else text="每个会员当天只能评价一次哦，明天再来吧~" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import empty from '@/components/common/empty'
import product from './add/product'
import star from './add/star'
import serviceStar from './add/serviceStar'
import comment from './add/comment'
import upload from './add/upload'
import actionbar from '../../order/actionbar'
import singleStar from './add/singleStar'

export default {
  components: {
    star,
    comment,
    upload,
    actionbar,
    singleStar,
    product,
    serviceStar,
    empty
  },
  props: {},
  data() {
    return {
      posting: false,
      toSku: false,
      touid: '',
      canComment: true
    }
  },
  computed: {
    ...mapState([
      'order',
      'tagList',
      'commentDigest',
      'newComment',
      'commentObj'
    ])
  },
  methods: {
    ...mapMutations(['setNewComment', 'setCommentObj']),
    async getVorderDetail() {
      try {
        const orderId = this.$route.params.orderCode
        const uid = this.$$cookie('uid')
        const skey = this.$$cookie('skey')
        const json = await this.$store.dispatch('getOrderDetail', {
          orderCode: orderId,
          uid,
          skey,
          toComment: true
        })
        console.log(json)
        this.getTags()
        this.getCommentDigest()
      } catch (e) {
        console.log(e)
      }
    },
    async getTags() {
      try {
        const object_id = this.order.sku_id
        // if (!object_id) return false
        await this.$store.dispatch('getTags', object_id)
      } catch (e) {
        console.log(e)
      }
    },
    async getCommentDigest() {
      try {
        await this.$store.dispatch('getCommentDigest')
      } catch (e) {
        console.log(e)
      }
    },
    async postCommentToSku() {
      try {
        if (this.posting) return
        this.posting = true
        if (this.order.orderState === 30) {
          const object_id = this.order.spuId
          if (!object_id) {
            this.$$toast('系统异常')
            return false
          }
          // if (this.newComment.tag_topics) {
          //     this.setNewComment({ score: this.newComment.score + 2 })
          // }
          // if (this.newComment.imageUrls || this.newComment.content) {
          //     this.setNewComment({ score: this.newComment.score + 4 })
          // }
          if (!this.newComment.content) {
            this.setNewComment({ content: '该用户没有评论内容' })
          }
          // this.setNewComment({ score1: this.newComment.score })
          const json = await this.$store.dispatch('postComment')
          if (json.code === '1') {
            const query = this.$$queryString.stringify({
              spuId: this.order.spuId,
              home_worker_uid: this.order.workerUid,
              // cid: json.
              cmd: 'share',
              sharetype: 0,
              refresh: 'no'
            })
            location.replace(
              `${this.$$hostname('life')}/v/order/${
                this.$route.params.orderCode
              }/comment/success?${query}`
            )
          } else if (json.code === '4') {
            this.$$login()
          } else {
            this.$$toast(json.message)
          }
        } else if (this.order.orderState === 40) {
          this.$$toast('已评价')
        } else {
          this.$$toast('不可评价')
        }
        this.posting = false
        this.$$tracker('110802', '20000', 21072, this.order.orderId)
      } catch (e) {
        console.log(e)
        this.posting = false
      }
    },
    async postCommentToPerson() {
      try {
        console.log('ssss')
        this.$$ensureLogin()
        if (this.posting) return
        this.posting = true
        if (this.commentObj.tags) {
          this.setCommentObj({ score: this.commentObj.score + 2 })
        }
        if (this.commentObj.pic_lists || this.commentObj.content) {
          this.setCommentObj({
            score: this.commentObj.score + 4,
            image_urls: this.commentObj.pic_lists
          })
        }
        // if (!this.commentObj.content) {
        //     this.setCommentObj({ content: '该用户没有评论内容', object_id: this.touid })
        // } else {
        this.setCommentObj({ object_id: this.touid })
        // }
        const json = await this.$store.dispatch('postNewComment')
        if (json.code === 1001) {
          this.$$toast('评论成功')
          setTimeout(() => {
            location.replace(
              `${this.$$hostname('life')}/v/user/${this.$route.params.uid}`
            )
          }, 1000)
        } else if (json.code === 1024) {
          this.$$login()
        } else {
          this.$$toast(json.message)
        }
        this.posting = false
      } catch (e) {
        console.log(e)
        this.posting = false
      }
    },
    async getCommentsByUid() {
      try {
        const query = {
          toUid: this.touid,
          uid: this.$$cookie('uid')
        }
        const commntJson = await this.$store.dispatch(
          'getMemberEvaluateByPerson',
          query
        )
        if (commntJson.code === 1001) {
          if (
            commntJson.data &&
            commntJson.data.list &&
            commntJson.data.list.length > 0
          ) {
            const data = commntJson.data.list[0]
            const date = this.$$dateFormat(
              new Date(data.created_at * 1000),
              'YY-MM-DD'
            )
            const now = this.$$dateFormat(new Date(), 'YY-MM-DD')
            if (date === now) {
              this.canComment = false
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  created() {
    if (this.$route.name === 'comment-user-add') {
      this.touid = this.$route.params.uid
      this.toSku = false
      this.getCommentsByUid()
      this.getTags()
      this.getCommentDigest()
    } else {
      this.toSku = true
      this.getVorderDetail()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin';
.comment {
  position: relative;
  padding: 0 rem(24px);
  background-color: #fff;
  padding-bottom: rem(230px);
}

.comment-way {
  position: fixed;
  bottom: rem(98px);
  width: 100%;
  left: 0;
  z-index: 99;
  background-color: #fee7a0;
  margin-top: rem(21px);
  padding: rem(21px) rem(20px);
  font-size: rem(28px);
  line-height: rem(44px);
  color: #9a7126;
  .icon-jiantou {
    position: absolute;
    z-index: 2;
    right: rem(20px);
    font-size: rem(24px);
    color: #000;
    line-height: rem(44px);
    font-weight: bolder;
    transform: rotate(-90deg);
  }
}
.post-comment {
  background-color: #ff397e;
  padding: rem(28px) 0;
  text-align: center;
  font-size: rem(36px);
  color: #fff;
  line-height: rem(44px);
}
</style>
